import { IResponse } from "models";

export enum ActionType {
  MINI_STRESS_INFO = "action/MINI_STRESS_INFO",
  MINI_STRESS_INFO_SUCCESS = "action/MINI_STRESS_INFO_SUCCESS",
  MINI_STRESS_INFO_ERROR = "action/MINI_STRESS_INFO_ERROR",
  MINI_STRESS_INFO_RESET_DATA = "action/MINI_STRESS_INFO_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface MiniStressTypeInfoData {
  page: number;
  per_page: number;
  not_implement: boolean;
  start_date?: string;
  end_date?: string;
  need_attention: boolean;
  high_stress_1: boolean;
  high_stress_2: boolean;
  locale?: string;
}

export interface IMiniStressTypeInfoResponse extends IResponse {
  total_record: number;
  current_page: number;
  next_page: number;
  result?: {
    mini_stress_result: IMiniStressTypeInfo[];
    stress_check_users: IMiniStressCheckUser[];
  };
}

export interface IMiniStressTypeInfo {
  stress_check_id: number;
  user_id: string;
  patient_id: string;
  name: string;
  date_of_implementation: string;
  stress_situation: number;
  interview_transmission_status: number;
  B: string;
  A_C: string;
  affiliation: string;
  gender: string;
  stress_check_done: boolean;
}

export interface IMiniStressCheckUser {
  patient_id: string;
  name: string;
  stress_situation: string;
}
